exports = module.exports = require("../../../../node_modules/.0.28.7@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "._29f-XvcOGPZSdbzCwt5Z4H{padding-left:200px;position:relative}.Z1ui63BoK-cbqIhkzeitv{width:200px;position:absolute;left:0;top:0}._2pAMZvghV_dWpH2wIujmCf{padding:30px 20px}", "", {"version":3,"sources":["/work/moapi/src/routes/project/components/Layout.less"],"names":[],"mappings":"AAAA,yBACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,uBACE,YAAa,AACb,kBAAmB,AACnB,OAAQ,AACR,KAAO,CACR,AACD,yBACE,iBAAmB,CACpB","file":"Layout.less","sourcesContent":[".content {\n  padding-left: 200px;\n  position: relative;\n}\n.menu {\n  width: 200px;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.main {\n  padding: 30px 20px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"content": "_29f-XvcOGPZSdbzCwt5Z4H",
	"menu": "Z1ui63BoK-cbqIhkzeitv",
	"main": "_2pAMZvghV_dWpH2wIujmCf"
};


// WEBPACK FOOTER //
// ./node_modules/.0.28.7@css-loader?{"importLoaders":1,"minimize":true,"modules":true,"sourceMap":true}!./node_modules/.2.0.8@postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/assets/fonts/antd/iconfont/""}}!./src/routes/project/components/Layout.less